import * as CubiqTS from "../../../../cubiq-model-multi-asset";
import { Injectable } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { CubiqWorker } from "../../../worker/CubiqWorker";
import { NotificationService } from "./NotificationService";
import { INotificationEvent } from "shared/cubiq-services/model/core/notifications/INotificationEvent";
import { BFXNotificationType } from "shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationEventType } from "shared/cubiq-services/model/core/notifications/BFXNotificationEventType";

/**
 * Inflight algo check event as it appears in backend (class simple name)
 */
const EVENT_TYPE_INFLIGHT_ALGO: string = "InflightCheckEvent";

@Injectable()
export class InflightAlertNotificationService {
  constructor(private worker: CubiqWorker, private notificationService: NotificationService) {
    this.initialize();
  }

  /**
   * Initialize subscriptions to process the inflight alert
   */
  protected initialize(): void {
    logger.out.info(`${this.constructor.name}: Subscribing for inflight alert events ...`);
    this.worker
      .getEncodableObservable(CubiqTS.ApplicationMessageEventImpl.name)
      .subscribe(this.processApplicationMessage.bind(this));
  }

  /**
   * Process application message if the message type is an inflight check event
   * @param message application message to process
   */
  public processApplicationMessage(message: CubiqTS.ApplicationMessageEvent): void {
    if (
      message != null &&
      message.messageType === EVENT_TYPE_INFLIGHT_ALGO &&
      message.message instanceof CubiqTS.InflightCheckEventImpl
    ) {
      try {
        this.processEvent(message.message as CubiqTS.InflightCheckEventImpl);
      } catch (e) {
        logger.out.error(`${this.constructor.name}: Failed to process inflight alert event ` + e);
      }
    }
  }

  /**
   * If inflight alert notification is enabled creates notification event and publishes it to notification service
   * @param event the event to create a notification based on
   */
  public processEvent(event: CubiqTS.InflightCheckEventImpl): void {
    if (event != null) {
      if (event.orderData != null && event.orderData.orderId && event.orderData.orderId.toString) {
        let orderId: string = event.orderData.orderId.toString();
        let msg: string = `${orderId} [${event.actionType}, ${event.ruleName}]`;
        logger.out.info(`${this.constructor.name}: Processing inflight alert event ${msg}`);
      }

      if (
        this.notificationService.shouldNotify(
          BFXNotificationType.ALGO_INFLIGHT,
          CubiqTS.OrderType.ALGO,
        )
      ) {
        let notificationEvent: INotificationEvent =
          this.notificationService.inflightAlertEventToNotification(event);
        if (notificationEvent != null) {
          this.notificationService.fireNotificationEvent(
            notificationEvent,
            BFXNotificationEventType.ALGO_INFLIGHT_EVENT,
          );
        }
      }
    }
  }
}
